import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {MaPlatePreparationService} from '../ma-plate-preparation/ma-plate-preparation.service';
import {MasterDataService} from '../masterdata/masterdata.service';
import {WorkFlow} from '../masterdata/models/workFlow';
import {MessagesService} from '../messages/messages.service';
import {Plate} from '../models/plate';
import {Sample} from '../models/sample';
import {Step} from '../models/step';
import {ErrorHandler} from '../utils/error-handler';
import {ProcessFlow} from '../masterdata/models/processFlow';
import {PlateStatus, ProcessStep, ProcessUpdateStage} from '../models/process-step';
import {AnnouncedService} from '../apg-announced/services/announced.service';
import {SampleCommentDTO} from '../models/sampleCommentDTO';
import {Comment} from '../models/comment';
import {SamplePlateHistoryDTO} from '../models/samplePlateHistoryDTO';
import {MaStorageService} from '../ma-storage/ma-storage.service';
import {StoragePlateDTO} from '../models/storagePlateDTO';
import {priorityMap} from '../utils/priority-row';
import {ApgDeliveryService} from '../apg-delivery/apg-delivery.service';
import {showLatestComment} from "../utils/latest-comment-util";
import { formatDate,DatePipe } from "@angular/common";
import prepareRemoveSampleDTO from "../utils/remove-sample-util";
import {ProcessUpdateDTO, SampleData} from "../models/wb-process-update";
import { PlateListDTO } from '../dto/plateListDTO';

@Component({
  selector: 'app-ma-preparation-qc-scan',
  templateUrl: './ma-preparation-qc-scan.component.html',
  styleUrls: ['./ma-preparation-qc-scan.component.css']
})
export class MaPreparationQcScanComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  readonly showLatestComment = showLatestComment;

  loading: boolean;
  blocked: boolean;
  selectedLabId: string;
  puid: string;
  plateToSearch: string = "";
  sampleToSearch: string = "";
  workFlowList = [];
  workFlowData: WorkFlow[] = [];

  plates: Plate[] = []
  selectedPlate: Plate;
  selectedPlateStepsMap: Map<string, Step>;
  objectIdBarcodeMap: Map<string,string> = new Map();
  plate: Plate;
  sample: Sample = new Sample();
  selectedTabIndex: number = 0;
  storageList: Array<string> =[];

  columnHeaders = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  rowHeaders = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
  selectedCell: string = 'A1';

  scannedBarcode: string = '';
  previousScannedBarcode: string = '';
  sampleBarcodeMap: Map<string,string> = new Map();
  plateSampleMap = new Map();
  showSampleCheckFailedDialog: boolean = false;
  showSampleMismatchDialog : boolean = false;
  plateSample: any;
  processFlows : ProcessFlow[];
  processFlowNameProcessFlowMap: Map<string,ProcessFlow> = new Map();
  topBarcode: string;
  bottomBarcode: string;
  missmatchSample: any;
  statusFilterList = [PlateStatus.RECEIVED, PlateStatus.RECEPTION_COMPLETED, PlateStatus.QCSCAN_STARTED, PlateStatus.QCSCAN_COMPLETED];
  selectedProcessFlows: ProcessFlow[];
  isQCScan: boolean = true;
  @Input() isQCScanSelectedFromPreparationComponent: boolean;
  @Input() tabId: number;
  @Input() scannedPlateID: string;
  newComment: string = '';
  showCommentsDialog: boolean = false;
  tableSelectedRow: Plate;
  selectedStorageLocation:any;
  showStoreDialog = false
  sampleList: String[] = [];
  sampleIDList: String[] = [];
  samplePositionList: string[] = [];
  barcodeIDMap: Map<String, String> = new Map();
  barcodePositionMap: Map<string, string> = new Map();
  enteredSampleId = "";
  removeSamples: boolean = false;
  qcScan: boolean = true;
  selectedPlateStatus: string;
  selectedPlateID: string = "";
  beadChipCommentsMap :Map<string, Comment[]> = new Map<string, Comment[]>();
  beadChipCommentsDisplayMap:Map<string, boolean> = new Map<string, boolean>();
  plateCommentsList: any;
  fetchedCommentsPlate: Plate;
  filterOptions: any[];
  selectedStatuses: string[] = [];
  selectedProcessFlowList: string[] = [];
  fromDate: Date = new Date();
  processFlowsList = [];
  sampleData: Sample[];
  wellPositionMap = new Map();
  sampleCheckErrorMessage: string = '';
  sampleQC: string;
  selectedPlateHistory: SamplePlateHistoryDTO[] = [];
  receivedSamplesInPlateMap = new Map();
  selectNewSampleToplatePopup: boolean = false;
  moveOrReplacePopup: boolean = false;
  showSampleAsidePouUp: boolean = false;
  sampleInfo: Sample[];
  @ViewChild('fileUploaderInternal')
  fileUploadElement: any;
  showSampleNotPresentDialog: boolean = false;
  qcScanPostionMap:  Map<String, String> = new Map();
  duplicateSamplesPresent: boolean = false;
  selectedPickedSample: Sample = new Sample();
  showQcScanNotCompletedPopup: boolean = false;
  topBarcodeID: string;
  topBarcodeData:Sample;
  boxReceptionTimeStamp: Date;
  isProcessUpdateProxied:boolean
  selectedWorkFlow:WorkFlow;
  sudoBarcode:string;
  sampleCommentsForPlate: string ='';
  showReceptionBarcode: boolean = false;
  showQCBarcode: boolean = false;
  replaceAnnouncedBarcodeColor: string = '#f26162';
  replaceFileBarcodeColor: string = '#f26161';
  switchedSampleColor: string ='#ffa500';
  movedOrReplacedSample:Sample = null;
  newSampleAddedWithoutMovingOrReplacing = false

  showDueDate = false;
  constructor(
      private readonly masterDataService: MasterDataService,
      private readonly announcedService: AnnouncedService,
      private readonly _messagesService: MessagesService,
      private readonly platePreparationService: MaPlatePreparationService,
      private readonly storageService:MaStorageService,
      private readonly deliveryService: ApgDeliveryService,
      private readonly datePipe:DatePipe
  ) { }

  ngOnInit() {
    this.puid = localStorage.getItem("PUID");
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    const isDateRange = JSON.parse(localStorage.getItem('lab')).lab.dateRange;
    this.checkQCScan();
    this.getAllProcessFlows();
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = []
    this.selectedPlateStepsMap = new Map();
    if (isDateRange) {
      this.fromDate.setDate(new Date().getDate() - 5);
    } else {
      this.fromDate.setDate(new Date().getDate() - 31);
    }
    this.fetchReceivedPlates(undefined, undefined, this.fromDate);
    if(this.scannedPlateID && this.tabId == 0) {
      this.searchForPlateAction(this.scannedPlateID);
      this.scannedPlateID = null;
    }

    this.selectedWorkFlow = JSON.parse(localStorage.getItem("selectedWorkFlow"))
    this.isProcessUpdateProxied = this.selectedWorkFlow.proxyWeatherbyAPI
    this.blocked = true
    this.storageService.fetchActiveStorageLocations(this.selectedLabId).subscribe({
      next : (result) => {
        this.storageList = result.datalist
        this.blocked = false
      },
      error: (_error: any) => {
        this.blocked = false
      }}
    )
    this.selectedStorageLocation = ''

    this.filterOptions = [
      { label: 'Reception Completed', value: PlateStatus.RECEPTION_COMPLETED },
      { label: 'Qc Scan Started', value: PlateStatus.QCSCAN_STARTED},
      { label: 'QC Scan Completed', value: PlateStatus.QCSCAN_COMPLETED}
    ];
  }

  ngOnChanges() {
    this.ngOnInit();
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  getAllProcessFlows() {
    this.processFlowNameProcessFlowMap.clear();
    this.blocked = true;
    this.masterDataService.getConfigList(this.selectedLabId, 'processFlow', 0, 100, true).subscribe({next : (results) => {
      this.blocked = false;
      if(results && results.data){
        this.processFlows = results.data;
        this.processFlowsList = [];
        this.processFlows.forEach(p => {
          this.processFlowNameProcessFlowMap.set(p.processFlowName, p);
          this.processFlowsList.push({ label: p.processFlowName, value: p.processFlowName });
        })
      }
    }, error: (error: any) => {
      this.blocked = false;
      this.showError(error);
    }})
  }

  checkQCScan(){
    this.selectedProcessFlows = JSON.parse(localStorage.getItem('selectedProcessFlows'));
    this.isQCScan = false;
    for(let i=0; i<this.selectedProcessFlows.length; i++){
      if(this.selectedProcessFlows[i].qcScan){
        this.isQCScan = true;
        break
      }
    }
    if(this.isQCScanSelectedFromPreparationComponent){
      this.getAnnounedPlates();
      this.isQCScanSelectedFromPreparationComponent = false;
    }
    return true
  }

  preparePlateSearchDTO(labId: string, type?: string, status?: string, processFlowName?: string, fromDate?: Date): PlateListDTO {
    const plateListDTO = new PlateListDTO();
    plateListDTO.labId = labId;
    if (typeof type !== 'undefined') {
      plateListDTO.type = type;
    }
    if (typeof status !== 'undefined') {
      plateListDTO.status = status;
    }
    if (typeof processFlowName !== 'undefined') {
      plateListDTO.processFlowName = processFlowName;
    }
    if (fromDate !== undefined && fromDate !== null) {
      plateListDTO.fromDate = formatDate(fromDate, 'yyyy-MM-dd', 'en-US')
    }
    return plateListDTO;
  }

  getAnnounedPlates() {
    if (this.isQCScan) {
      this.loading = true;
      this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE", this.statusFilterList.join(','))).subscribe({
        next: (result) => {
          this.loading = false;
          this.plates = result;
          if (this.selectedPlate.plateID != null) {
            for (let i = 0; i < this.plates.length; i++) {
              if (this.selectedPlate.plateID == this.plates[i].plateID) {
                this.tableSelectedRow = this.plates[i]
                break
              }
            }
          }
        },
        error: (error: any) => {
          this.loading = false;
          console.log("Error in fetching received plates ", error);
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Failed to fetch plates',
            detail: 'Some issue in pulling the plates info, please try again'
          })
        }
      })
    }
    else {
      this.plates = [];
    }
  }

  savePlate(){
    this.selectedPlate.samples = Array.from(this.plateSampleMap.values())
    this.selectedPlate.samples.forEach((sam, index) => {
      if (sam.sampleID == '' || sam.sampleID == null) {
        this.selectedPlate.samples.splice(index, 1);
      }
    }
    );
    this.selectedPlate.sendHistoryEvents = false
    this.updatePlate();
  }

  updatePlate() {
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please  enter USER ID before moving ahead',
      });
      return;
    }
    this.selectedPlate.lastUpdatedPlateID = this.selectedPlate.plateID;
    this.blocked = true;
    this.platePreparationService.updatePlate(this.selectedPlate.plateID,this.selectedPlate,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.prepareProcessStepsMap();
        if(this.selectedPlate.storagePlate && this.selectedPlate.status !== PlateStatus.STORAGE_PLATE){
          this.selectedPlate.version +=1
          this.restorePlatesFromStorage([this.selectedPlate.plateID],() => {})
        }
        if(this.moveOrReplacePopup || this.newSampleAddedWithoutMovingOrReplacing){
            this.sendAssignedUpdateToWeatherbys(this.movedOrReplacedSample);
            this.moveOrReplacePopup = false;
            this.newSampleAddedWithoutMovingOrReplacing = false;
        }
        this.getAnnounedPlates()
        this.prepareSamplesMap();
        this.showComments();
        this.sampleData = [];
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Plate '+this.selectedPlate.plateID+' is updated',
          detail: this.selectedPlate.plateID + ' has been updated successfully!'
        })
        setTimeout(() => {
          this.findAndHighlightElement('barcode-scanner')
        },500)
      }, error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })

  }

  showPlateInfo(event) {
    this.searchForPlateAction(event.data.plateID);
  }

  removePlateSelection(){
    this.selectedPlate = new Plate();
    this.selectedPlate.samples = []
    this.selectedPlateStepsMap = new Map();
    this.selectedCell = 'A1';
    this.sampleBarcodeMap.clear();
    this.plateSampleMap.clear();
    this.selectedPlateID = ""
    this.selectedPlateStatus = "";
    this.plateCommentsList = [];
    this.beadChipCommentsDisplayMap.clear()
    this.beadChipCommentsMap.clear()
  }

  fetchStorageNameForPlate(plateId:string){
    this.blocked = true
    this.storageService.searchStorageByPlate(this.selectedLabId,plateId).subscribe({
      next : (storage) => {
        this.blocked = false
        this.selectedPlate.storage = storage.storageName
      },
      error: (error: any) => {
        this.blocked = false
        console.error(error)
      }
    })
  }

  restorePlatesFromStorage(plates:string[] = [], callBack : () => void){
    let body = {
      "labid":this.selectedLabId,
      "plateids":plates
    }
    this.blocked = true
    this.storageService.removeMultiplePlatesFromStorage(body).subscribe({
      next : (_r) => {
        let data = {
          'plateIDs':plates
        }
        this.storageService.restorePlatesFromStorage(this.selectedLabId,data).subscribe({
          next : (_r) => {
            this.blocked = false
            callBack()
          },
          error: (error: any) => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity:'error',summary:'Something went wrong while restoration',
              detail:error
            })
            callBack()
          }}
        )
      },
      error: (error: any) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while restoration',
          detail:error
        })
        callBack()
      }
    })
  }

  searchForPlateAction(plateID: string){
    this.blocked = true;
    this.platePreparationService.fetchPlate(plateID,this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedPlate = result;
        this.fetchStorageNameForPlate(this.selectedPlate.plateID)
        this.selectedPlate.samples.forEach((res) => {
          this.objectIdBarcodeMap.set(res.sampleID, res._id)
        })
        this.qcScanPostionMap.clear();
        this.selectedPlate.samples.forEach(samp => {
          if(samp.color == "white"){
            this.qcScanPostionMap.set(samp.position, samp.sampleID)
          }
        })
        this.fetchBoxDetails(this.selectedPlate.delivery);
        this.getSelectedCellPosition();
        this.showComments();
        if (result != null && result.sampleType != null) {
          this.fetchProcessFlow(this.selectedPlate);
        } else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'BatchID : ' + this.plateToSearch,
            detail: this.plateToSearch + '  does not need a Sample QC scan'
          });
          this.selectedPlateStepsMap = new Map()
          this.plateToSearch = "";
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.showError(error);
      }
    })
  }

  fetchBoxDetails(boxId) {
    this.blocked = true
    this.deliveryService.validateBox(boxId, this.selectedLabId).subscribe({
      next : (result) => {
        this.blocked = false;
        let boxDetails = result.data;
        this.boxReceptionTimeStamp = this.convertToDate(boxDetails.receptionDate);
      },
      error: (error: any) => {
        this.blocked = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: "Error occured while validating box.",
          detail: error.error
        })
      }
    });
  }

  fetchProcessFlow(selectedPlate: Plate) {
    if(this.processFlowNameProcessFlowMap.has(selectedPlate.processFlowName) && this.processFlowNameProcessFlowMap.get(selectedPlate.processFlowName).qcScan
    && this.processFlowNameProcessFlowMap.get(selectedPlate.processFlowName).active){
        this.blocked = false;
        this.prepareProcessStepsMap();
        this.prepareSamplesMap();
    }
    else{
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'BatchID : ' + this.plateToSearch,
        detail: this.plateToSearch + '  does not need a Sample QC scan'
      });
      this.plateToSearch = "";
    }
  }

  selectTableCell(row: number, col: number){
    if(this.selectedPlate.plateID != undefined || this.selectedPlate.plateID != null){
      this.selectedCell = this.getRowColStringFromPos(row, col);
      this.selectedCellPopUp(this.selectedCell);
      this.findAndHighlightElement('barcode-scanner')
    }
    else
      this.selectedCell = 'A1';
  }

  selectedCellPopUp(selectedCell: string) {
    this.selectedPlate.samples.forEach(sample => {
      if ((sample.color == this.replaceAnnouncedBarcodeColor || sample.color == this.switchedSampleColor) && sample.position == selectedCell) {
        this.showReceptionBarcode = true;
        this.previousScannedBarcode = "";
        this.showSampleCheckFailedDialog = true;
      } else if ((sample.color == this.replaceFileBarcodeColor || sample.color == "orange") && sample.position == selectedCell) {
        this.showReceptionBarcode = false;
        this.showQCBarcode = true;
        this.previousScannedBarcode = "";
        this.showSampleCheckFailedDialog = true;
      }
    })
  }

  getReceptionBarcodeByColor() {
    let receptionBarcode = '""';
    let scan = this.plateSampleMap.get(this.selectedCell)
    if (this.selectedPlate?.samples) {
      this.selectedPlate.samples.forEach(sample => {
        if ((sample.color === this.replaceFileBarcodeColor || sample.color === 'orange') && this.selectedCell === sample.position) {
          receptionBarcode = this.getReceptionBarcode();
        } else if (this.missmatchSample) {
          receptionBarcode = scan?.sampleID;
        }
      });
    }
    return receptionBarcode;
  }

  getQCScanBarcodeByColor() {
    let qcScanBarcode = '""';
    if (this.missmatchSample || this.scannedBarcode !== '') {
      qcScanBarcode = this.scannedBarcode;
    }
    if (this.selectedPlate?.samples) {
      this.selectedPlate.samples.forEach(sample => {
        if ((sample.color === this.replaceAnnouncedBarcodeColor || sample.color === this.switchedSampleColor) && this.selectedCell === sample.position) {
          qcScanBarcode = this.getReceptionBarcode();
        } else if ((this.showQCBarcode && sample.color === this.replaceFileBarcodeColor || sample.color == "orange") && this.selectedCell === sample.position) {
          qcScanBarcode = this.getQCScanBarcode();
        }
      });
    }
    return qcScanBarcode;
  }

  getReceptionBarcode() {
    return this.sampleBarcodeMap.has(this.selectedCell) ? this.sampleBarcodeMap.get(this.selectedCell) : '""';
  }

  getQCScanBarcode() {
    let scannedPosition = this.plateSampleMap.get(this.selectedCell);
    if (scannedPosition && scannedPosition.qcSampleHistory) {
      return scannedPosition.qcSampleHistory[scannedPosition.qcSampleHistory.length - 1] || '""';
    } else {
      return this.scannedBarcode || '""';
    }
  }

  getSelectedCell(){
    return this.selectedCell;
  }
  markPlatesAsStorage(){
    let body = {
      'storageLocation': this.selectedStorageLocation["storageName"],
      'plateIDs':[this.selectedPlate.plateID]
    }
    this.blocked = true
    this.storageService.markPlatesAsStorage(this.selectedLabId,body).subscribe({
      next : (_r) => {
        this.blocked = false
        this.showStoreDialog = false
      } ,
      error: (error: any) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Somthing went wrong',
          detail:error
        })
        this.showStoreDialog = false
        return
      }}
    )
  }

  saveBarcode(){
    if(!this.isPUIDPresent()){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'USER ID not present!',
        detail: 'Please enter USER ID before moving ahead',
      });
      return;
    }
    this.scannedBarcode = this.scannedBarcode.trim();
    this.sudoBarcode = this.scannedBarcode
    this.showReceptionBarcode = false;
    this.showQCBarcode = false;
    if(this.scannedBarcode == ''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Barcode Empty',
        detail: 'Please scan a valid barcode',
      });
      return;
    }
    this.blocked = true;
    this.sampleQC = this.scannedBarcode;
    if(this.objectIdBarcodeMap.has(this.scannedBarcode)){
      this.sampleQC = this.objectIdBarcodeMap.get(this.scannedBarcode);
      this.fetchSampleDetails();
    }
    else{
      this.announcedService.getSampleFromDelivery(this.selectedLabId,this.scannedBarcode).subscribe({
        next : (result) => {
          if(result.data){
            this.sampleData = result.data
            if(this.sampleData.length>=1){
              this.sampleQC = this.sampleData[0]._id
              this.fetchSampleDetails();
            }
          }
        },
        error: (error: any) => {
          this.blocked = false;
          this._messagesService.addErrorMessage({
            severity:"error", summary:" Sample "+this.scannedBarcode+" not announced.",
            detail: "Sample is not announced"
          })
        }});
    }
  }

  private fetchSampleDetails() {
    this.platePreparationService.fetchSampleDetailsBySampleID(this.selectedLabId, this.sampleQC).subscribe({
      next: (result) => {
        this.blocked = false;
        this.sample = result.samples[0];
        if (this.selectedCell == this.sample.position && this.selectedPlate.plateID == result.plateID) {
          this.setGreenColorToCell();
        }
        else if (this.selectedPlate.plateID == result.plateID && this.selectedCell != this.sample.position) {
          this.plateSample = this.plateSampleMap.get(this.selectedCell);
          this.showSampleMismatchDialog = true;
        } else if (this.selectedPlate.plateID != result.plateID) {
          if(this.sample.singleRedo || this.sample.plateRedo){
            this.missmatchSample = this.plateSampleMap.get(this.selectedCell);
            if (this.missmatchSample != null || this.missmatchSample != undefined) {
              this.missmatchSample.qcSampleHistory.push(this.scannedBarcode);
            }
            this.showSampleCheckFailedDialog = true;
            this.previousScannedBarcode = this.scannedBarcode;
            this.findAndHighlightElement('barcode-scanner');
          }else{
            this._messagesService.addWarningMessage({
              severity: 'warn', summary: this.scannedBarcode + ' is not related to this PlateID',
              detail: 'Please scan a valid barcode',
            });
            this.scannedBarcode = '';
            this.topBarcode = '';
            this.bottomBarcode = '';
            return;
          }
        }
      },
      error: (error: any) => {
        this.blocked = false;
        this.missmatchSample = this.plateSampleMap.get(this.selectedCell);
        if (this.missmatchSample != null || this.missmatchSample != undefined) {
          this.missmatchSample.qcSampleHistory.push(this.scannedBarcode);
        }
        this.showSampleCheckFailedDialog = true;
        this.previousScannedBarcode = this.scannedBarcode;
        this.findAndHighlightElement('barcode-scanner');
      }
    }
    );
  }

  closeTopAndBottomBarcodePopup() {
    this.topBarcode = this.topBarcode.trim();
    let scannedPosition = this.plateSampleMap.get(this.selectedCell);
    if (!scannedPosition || scannedPosition.sampleID != this.topBarcode) {
      this.checkBarcodePresentInPlate();
    } else if (scannedPosition && scannedPosition.sampleID == this.topBarcode) {
      this.setGreenColorToCell();
      this.showSampleCheckFailedDialog = false;
      this.topBarcode = '';
      this.bottomBarcode = '';
    }
  }

  checkBarcodePresentInPlate() {
    let checkBarcodePresent = false;
    for (let i = 0; i <= this.selectedPlate.samples.length - 1; i++) {
      if (this.selectedPlate.samples[i].sampleID == this.topBarcode) {
        this.topBarcodeData = this.plateSampleMap.get(this.selectedPlate.samples[i].position);
        this.scanningPosition();
        checkBarcodePresent = true;
        break;
      }
    }
    if(!checkBarcodePresent){
      this.closeSampleCheckFailedDialog();
    }
    return !checkBarcodePresent;
  }

  scanningPosition() {
    let scannedPosition = this.plateSampleMap.get(this.selectedCell);
    if (scannedPosition == null || scannedPosition == undefined) {
      this.sampleBarcodeMap.set(this.selectedCell, this.topBarcode);
      this.plateSampleMap.set(this.selectedCell, this.createNewSample(scannedPosition, this.topBarcode, this.selectedCell));
      scannedPosition = this.plateSampleMap.get(this.selectedCell);
      if (scannedPosition.sampleID == this.topBarcodeData.sampleID) {
        scannedPosition.sampleID = '';
      }
    }
    this.plateSampleMap.set(this.topBarcodeData.position, this.createNewSample(scannedPosition, scannedPosition.sampleID, this.topBarcodeData.position));
    let scan = this.plateSampleMap.get(this.topBarcodeData.position)
    scan.color = this.switchedSampleColor;
    if(scan.qcSampleHistory !=undefined){
      scan.qcSampleHistory.push(this.topBarcodeData.sampleID)
    }else{
      scan.qcSampleHistory =[]
    }
    this.newComment = "Reception "+scannedPosition.position +", QC-Scan " +this.topBarcodeData.position+ ", further processed "+this.topBarcodeData.position;
    this.saveComment(scannedPosition._id);
    this.plateSampleMap.set(this.topBarcodeData.position, scan);
    this.plateSampleMap.set(scannedPosition.position, this.createNewSample(this.topBarcodeData, this.topBarcodeData.sampleID, scannedPosition.position));
    let scan2 = this.plateSampleMap.get(scannedPosition.position);
    scan2.color = this.switchedSampleColor;
    if(scannedPosition.sampleID!=""){
      scan2.qcSampleHistory.push(scannedPosition.sampleID);
    }
    this.newComment = "Reception "+this.topBarcodeData.position +", QC-Scan " +scannedPosition.position+ ", further processed "+scannedPosition.position;
    this.saveComment(this.topBarcodeData._id);
    this.sampleCommentsForPlate = scannedPosition.position +": Sample "+  scannedPosition.sampleID +" was replaced with " +this.topBarcodeData.sampleID
    this.saveBottomBarcode();
    this.plateSampleMap.set(scannedPosition.position, scan2);
    this.showSampleMismatchDialog = false;
    this.showSampleCheckFailedDialog = false;
    this.blocked = false;
    this.previousScannedBarcode = this.scannedBarcode;
    this.scannedBarcode = '';
    this.sampleQC = '';
    this.topBarcodeData = new Sample();
    this.addSamplePosChangeCommentsToPlate();
    this.savePlate();
    this.incrementSelectedCell();
  }

  addSamplePosChangeCommentsToPlate() {
    const comments = new Comment();
    comments.comment = this.sampleCommentsForPlate + ` (PUID:${this.puid})`;
    comments.puid =  Comment.GENERATED_BY_SYSTEM_TAG;
    comments.status = this.selectedPlateStatus;
    comments.timeStamp = new Date();
    this.selectedPlate.comments.push(comments);
  }

  closeSampleCheckFailedDialog() {
    this.blocked = true;
    this.announcedService.getSampleFromDelivery(this.selectedLabId, this.topBarcode).subscribe({
      next : (result) => {
        this.blocked = false;
        if (result.data) {
          this.sampleData = result.data
          if (this.sampleData.length >= 1) {
            this.topBarcodeID = this.sampleData[0]._id
            this.fetchSampleDetailsBySampleID();
          }
        }
      },
      error: (_error: any) => {
        this.blocked = false;
        this.saveNotAnnouncedBarcodeInEmptyPosition();
        return;
      }})
  }

  fetchSampleDetailsBySampleID(){
    this.blocked = true;
    let isSampleRedo = false;
    this.platePreparationService.fetchSampleDetailsBySampleID(this.selectedLabId, this.topBarcodeID).subscribe({
      next : (result) => {
        this.blocked = false;
        let sampleData =   result.samples[0];
        if (sampleData.sampleID == this.topBarcode && (sampleData.singleRedo || sampleData.plateRedo)) {
          isSampleRedo = true;
        }
        if (this.selectedPlate.plateID !== result.plateID) {
          if (isSampleRedo) {
            this.addAnnouncedBarcodeToPlate();
          } else {
            this.blocked = false;
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Barcode : ' + this.topBarcode,
              detail: this.topBarcode + '  not related to this Plate'
            });
            this.topBarcode = '';
            this.bottomBarcode = '';
            this.scannedBarcode = '';
          }
          this.showSampleCheckFailedDialog = false;
        }
      },
      error: (error: any) => {
        this.addAnnouncedBarcodeToPlate();
        this.showSampleCheckFailedDialog = false;
      }
    });
  }

  addAnnouncedBarcodeToPlate(){
    this.blocked = false;
        this.sampleInfo = this.sampleData;
        let scannedBarcodeForPosition = this.plateSampleMap.get(this.selectedCell);
        if (scannedBarcodeForPosition && scannedBarcodeForPosition.sampleID == this.topBarcode) {
          this.setGreenColorToCell()
          this.topBarcode = '';
          this.bottomBarcode = '';
        } else{
          this.saveNotAnnouncedBarcode(this.sampleData);
        }
  }

  saveNotAnnouncedBarcode(sampleData: Sample[]) {
    if (sampleData && sampleData.length != 0) {
      if (sampleData.length == 1) {
        this.saveNotAnnouncedBarcodeInNotEmptyPosition(sampleData[0]);
      } else {
        this.showSampleMismatchDialog = false;
        this.duplicateSamplesPresent = true;
      }
    } else {
      this.saveNotAnnouncedBarcodeInEmptyPosition();
    }
  }

  saveNotAnnouncedBarcodeInNotEmptyPosition(sampleData: any) {
    if(!sampleData){
      this.saveNotAnnouncedBarcodeInEmptyPosition();
      return;
    }
    if(!sampleData.announced){
      this.sampleCheckErrorMessage =  `Sample ${sampleData.barCode} is not announced in the manifest`
      this.showSampleAsidePouUp = true;
      return
    }
    if(!sampleData.activated){
      this.sampleCheckErrorMessage = `Sample ${sampleData.barCode} is not activated.`
      this.showSampleAsidePouUp = true
      return
    }

    this.showSampleMismatchDialog = false;
    let scannedPosition = this.plateSampleMap.get(this.selectedCell)
    if (Array.from(this.sampleBarcodeMap.values()).length == 96 || scannedPosition == undefined) {
        this.newSampleAddedWithoutMovingOrReplacing = true;
        this.replaceAnnouncedBarcode();
      return;
    } else {
      this.moveOrReplacePopup = true;
    }

  }

  setBarcodeToSample(sudoBarcode:string,sample:Sample,callBack : (sample:Sample) => void){
    this.blocked = true
    this.announcedService.putBarcodeInSample(sudoBarcode,sample).subscribe({
      next : (result) => {
        this.blocked = false
        callBack(result.data)
      },
      error: (error: any) => {
        this.blocked = false
        this._messagesService.addErrorMessage({
          severity:'error',summary:'Something went wrong while setting up the barcode',
          detail:'Sample replacement failed since the barcode was not set'
        })
        return
      }
    })
  }

  sendAssignedUpdateToWeatherbys(sample:Sample) {
      const sampleData: SampleData = {
          sampleId:sample._id,
          description:"",
          stageGate: 2,
          status: ProcessUpdateStage.STAGE_GATE
      };
      const weatherbyProcessUpdateDto: ProcessUpdateDTO = {
          data: [sampleData],
          labId:this.selectedLabId
      };
      this.announcedService.weatherbyProcessUpdate(weatherbyProcessUpdateDto,this.isProcessUpdateProxied).subscribe({
          next: (_result) => {
              this._messagesService.addSuccessMessage({
                  severity:'success',summary:'Sample assigned',
                  detail: 'Sample has been marked as assigned.'
              });
          },
          error: (error) => {
              this.showError(error);
          }
      });
  }

  replaceAnnouncedBarcode() {
    let sample;
    if (this.duplicateSamplesPresent) {
      sample = this.selectedPickedSample;
    } else {
      sample = this.sampleInfo[0];
    }
    sample.color = this.replaceAnnouncedBarcodeColor;
    sample.qcSampleHistory = [];
    if(!sample.barCode){
      this.setBarcodeToSample(this.sudoBarcode,sample, (modifiedSample) => {
        sample.barCode = modifiedSample.barCode;
        this.savePlateAfterBarCodeSetting(sample);
      });
      this.sudoBarcode = '';
      return;
    }
    this.savePlateAfterBarCodeSetting(sample);
  }

  savePlateAfterBarCodeSetting(sample:Sample){
    let selectedSample = this.plateSampleMap.get(this.selectedCell);
    this.plateSampleMap.set(this.selectedCell, this.createNewSample(sample, sample.barCode, this.selectedCell));
    this.selectNewSampleToplatePopup = false;
    this.previousScannedBarcode = this.scannedBarcode;
    this.movedOrReplacedSample = sample;
    if(selectedSample){
      this.sampleCommentsForPlate = this.selectedCell +": Sample "+  selectedSample.sampleID +" was replaced with " +sample.barCode;
    }
    if (!this.duplicateSamplesPresent) {
      this.saveBottomBarcode();
    }
    this.addSamplePosChangeCommentsToPlate();
    this.savePlate();
    this.incrementSelectedCell();
    this.duplicateSamplesPresent = false;
    this.scannedBarcode = '';
  }

  moveReceptionBarcodes() {
    let selectedCell = this.selectedCell;
    let sample;
    if (this.duplicateSamplesPresent) {
      sample = this.selectedPickedSample;
    } else {
      if(!this.sampleInfo[0].qcSampleHistory){
        this.sampleInfo[0].qcSampleHistory = []
      }
      sample = this.sampleInfo[0];
    }
    if(!sample.barCode){
      this.setBarcodeToSample(this.sudoBarcode,sample, (modifiedSample) => {
        sample.barCode = modifiedSample.barCode;
        this.performMoveOperation(selectedCell,sample);
      });
      this.sudoBarcode = '';
    }
    else {
      this.performMoveOperation(selectedCell,sample);
    }
  }

  performMoveOperation(selectedCell:string,sample:Sample) {
    let presentBarcodeInCell;
    let flag = false;
    if (!this.selectedPlate.scanHorizontal) {
      this.columnHeaders.forEach(col => {
        this.rowHeaders.forEach(rowLetter => {
          let position = rowLetter + col;
          this.wellPositionMap.set(position, this.plateSampleMap.get(position) !== undefined ? true : false);
        });
      });
    } else {
      this.rowHeaders.forEach(row => {
        this.columnHeaders.forEach(colnumber => {
          let position = row + colnumber;
          this.wellPositionMap.set(position, this.plateSampleMap.get(position) !== undefined ? true : false);
        })
      })
    }
    if (this.sampleBarcodeMap.size < 96) {
      this.wellPositionMap.forEach((value1: string, position: string) => {
        if (flag) {
          let swiftBarcode = this.plateSampleMap.get(position);
          if (presentBarcodeInCell && position != undefined) {
            presentBarcodeInCell.position = position;
          } else {
            return;
          }
          this.plateSampleMap.set(position, presentBarcodeInCell);
          presentBarcodeInCell = swiftBarcode;
        }
        if (position === selectedCell) {
          presentBarcodeInCell = this.plateSampleMap.get(position);
          sample.position = position;
          sample.color = this.switchedSampleColor;
          sample.qcSampleHistory.push(presentBarcodeInCell.sampleID);
          this.plateSampleMap.set(position, this.createNewSample(sample, sample.barCode, position));
          flag = true;
        }
      });
    }
    this.selectNewSampleToplatePopup = false;
    this.previousScannedBarcode = this.scannedBarcode;
    if (!this.duplicateSamplesPresent) {
      this.saveBottomBarcode();
    }
    this.movedOrReplacedSample = sample;
    this.savePlate();
    this.incrementSelectedCell();
    this.duplicateSamplesPresent = false;
    this.scannedBarcode = '';
  }

  saveNotAnnouncedBarcodeInEmptyPosition() {
    let data = {};
    data["barCode"] = this.topBarcode;
    data["sampleType"] = this.selectedPlate.sampleType;
    data['announced'] = false;
    data['activated'] = false;
    data['workFlow'] = this.selectedPlate.workFlow;
    data['sender'] = this.selectedPlate.sender;
    data['boxID'] = this.selectedPlate.delivery;
    data['storage'] = this.selectedPlate.storagePlate;
    data['projectID'] = this.selectedPlate.samples.slice(-1)[0].projectID;
    let plateHistory = new SamplePlateHistoryDTO();
    plateHistory.approved = false;
    plateHistory.position = "";
    plateHistory.plateId = this.selectedPlate.plateID;
    data['plateHistory'] = [plateHistory];
    let comment = new SampleCommentDTO();
    comment.comment = this.sampleCheckErrorMessage;
    comment.puid = this.puid;
    comment.status = PlateStatus.QCSCAN_STARTED;
    data['comments'] = [comment]
    if(this.bottomBarcode!= undefined || this.bottomBarcode != null){
      data['bottomBarcode'] = this.bottomBarcode;
    }
    this.blocked=true;
    this.announcedService.addSample(this.selectedLabId, this.topBarcode, data).subscribe({
      next : (_result) => {
        this.blocked=false;
        this._messagesService.addSuccessMessage({
          severity:'success', summary:"Sample "+this.topBarcode+" created.",
          detail:"New Sample with sampleId "+this.topBarcode+" created and added."
        });
        this.sampleCheckErrorMessage = "Sample " + this.topBarcode + " was not announced in the manifest for project "
        this.showSampleNotPresentDialog = true;
        plateHistory.sampleId = this.scannedBarcode;
        this.selectedPlateHistory.push(plateHistory);
        this.receivedSamplesInPlateMap.set(this.scannedBarcode, true);
        this.previousScannedBarcode = this.scannedBarcode;
        this.scannedBarcode = '';
        this.bottomBarcode = '';
        this.topBarcode = '';
        this.showSampleMismatchDialog = false;
        this.showSampleCheckFailedDialog = false;
      },
      error: (error: any) => {
        this.blocked=false;
        this._messagesService.addErrorMessage({
          severity:"error", summary:" Sample "+this.scannedBarcode+" not created.",
          detail: error
        })
      }
    });
  }

  selectedSampleFromScan(sample) {
    this.blocked = false;
    this.selectedPickedSample = sample;
    this.duplicateSamplesPresent = false;
    let scannedPosition = this.plateSampleMap.get(this.selectedCell);
    let isPlateFilledOrPositionDoesNotHaveSample = Array.from(this.sampleBarcodeMap.values()).length === 96 || ( this.selectedPickedSample.announced && this.selectedPickedSample.activated && scannedPosition == undefined );
    if (isPlateFilledOrPositionDoesNotHaveSample) {
      this.replaceAnnouncedBarcode();
    } else if (
      this.selectedPickedSample.announced &&
      this.selectedPickedSample.activated
    ) {
      this.moveOrReplacePopup = true;
    } else {
      if (!this.selectedPickedSample.announced) {
        this.sampleCheckErrorMessage = `Sample ${this.selectedPickedSample.barCode} is not announced in the manifest`;
      } else if (!this.selectedPickedSample.activated) {
        this.sampleCheckErrorMessage = `Sample ${this.selectedPickedSample.barCode} is not activated.`;
      }
      this.showSampleAsidePouUp = true;
    }
  }

  saveBottomBarcode() {
    let missmatchSample = this.plateSampleMap.get(this.selectedCell);
    missmatchSample.bottomBarcode = this.bottomBarcode;
    missmatchSample.barCode = missmatchSample.sampleID;
    if(missmatchSample.activated== null || missmatchSample.activated== undefined){
      missmatchSample.activated= !this.selectedPlate.storagePlate;
    }
    this.newComment = "Top-Barcode : "+this.topBarcode+", "+"Bottom-Barcode : "+this.bottomBarcode+", "+"Processed-Barcode : "+ missmatchSample.barCode;
    this.saveComment(missmatchSample._id);
    this.announcedService.updateSample(this.selectedLabId, missmatchSample._id, missmatchSample).subscribe({
      next : (_result) => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
					severity:"success", summary: "Bottom barcode added to sample!"
				})
        this.scannedBarcode = '';
        this.previousScannedBarcode = '';
        this.topBarcode = '';
        this.bottomBarcode = '';
      },

      error: (error: any) => {
        this._messagesService.addErrorMessage({
          severity:"error", summary:"Update sample failed!",
          detail:"Bottom barcode of sample not updated."
        })
        this.scannedBarcode = '';
        this.previousScannedBarcode = '';
        this.topBarcode = '';
        this.bottomBarcode = '';
      }});
  }

  createNewSample(sampleInfo, barcode, position){
    let newSample = new Sample();
    if(sampleInfo!="" && sampleInfo != null && sampleInfo != undefined){
      newSample._id = sampleInfo._id;
      newSample.boxID = !sampleInfo.boxID ? this.selectedPlate.delivery : sampleInfo.boxID;
      newSample.boxReceptionTimeStamp = !sampleInfo.boxReceptionTimeStamp? this.boxReceptionTimeStamp : this.convertToDate(sampleInfo.boxReceptionTimeStamp);
      newSample.projectID = sampleInfo.projectID;
      newSample.color = sampleInfo.color;
      newSample.priority = sampleInfo.priority;
      newSample.gender = sampleInfo.gender;
      newSample.qcSampleHistory = sampleInfo.qcSampleHistory;
      newSample.icbfSampleID = sampleInfo.icbfSampleID;
      newSample.assignedSampleType = sampleInfo.assignedSampleType ?sampleInfo.assignedSampleType: "";
      newSample.autoRerun = sampleInfo.autoRerun;
      newSample.plateRedo = sampleInfo.plateRedo;
      newSample.singleRedo = sampleInfo.singleRedo;
      newSample.reRunCount = sampleInfo.reRunCount;
      newSample.reProcessed = sampleInfo.reProcessed;
      newSample.sampleType = sampleInfo.sampleType;
      newSample.dueDate = sampleInfo.dueDate;
      newSample.receptionPUID = this.puid;
      newSample.mintSampleID = sampleInfo.mintSampleID
      newSample.parentMintSampleID = sampleInfo.parentMintSampleID;
      newSample.parentSampleID = sampleInfo.barCode;
    }
    newSample.position = position;
    newSample.sampleID = barcode;
    newSample.beadChipID = '';
    newSample.beadChipPosition = '';
    newSample.redoBeadChipID = '';
    newSample.redoBeadChipPosition = '';
    newSample.toBePicked = false;
    newSample.bottomBarcode='';
    newSample.sourcePlateID=this.selectedPlate.plateID;
    newSample.sourcePlatePosition = position;
    return newSample;
  }

  incrementSelectedCell(){
    let row = this.selectedCell[0],col = Number.parseInt(this.selectedCell.substring(1)), rowDiff = 0;

    if(this.selectedPlate.scanHorizontal){
      let rowIndex
        rowIndex = col == this.columnHeaders[11]? this.rowHeaders.indexOf(row)+1 : this.rowHeaders.indexOf(row)
        row =  rowIndex == 8? this.rowHeaders[0] : this.rowHeaders[rowIndex]
        col = col == 12? 1 : col+1
          this.selectedCell = row+col;
    }
    else{
        col = row ==  this.rowHeaders[7]? col+1 : col;
        col = col==13? 1 : col;
        rowDiff = row.charCodeAt(0) - 'A'.charCodeAt(0)
        row = this.rowHeaders[rowDiff==7? 0 : rowDiff+1];
          this.selectedCell = row+col;
    }
  }

  checkSelectedCell(row, col){
    if(this.getRowColStringFromPos(row,col) == this.selectedCell)
      return true;
    return false;
  }

  checkScannedPosition(row, col){
    if(this.getRowColStringFromPos(row,col) == this.selectedCell)
      return true;
    return false;
  }
  checkReceptionPosition(row, col){
    if(this.getRowColStringFromPos(row,col) == this.sample.position)
      return true;
    return false;
  }

  prepareProcessStepsMap() {
    this.selectedPlateStepsMap.clear();
    if(!this.selectedPlate.processSteps || this.selectedPlate.processSteps==null)
      return;
    this.selectedPlate.processSteps.forEach(step => {
      this.selectedPlateStepsMap.set(step.step, step);
    })
  }

  prepareSamplesMap(){
    this.sampleBarcodeMap.clear();
    this.plateSampleMap.clear();
    this.selectedPlate.samples.forEach(sample => {
      this.sampleBarcodeMap.set(sample.position,sample.sampleID);
      this.plateSampleMap.set(sample.position,sample);
    })
  }

  findAndHighlightElement(elementId){
    let element = document.getElementById(elementId);
    if(element){
      element.focus();
    }
  }

  isValidProcessStep(stepName: string): boolean {
    return (this.selectedPlateStepsMap.get(stepName) != undefined && this.selectedPlateStepsMap.get(stepName) != null);
  }

  getProcessStepStartPuid(stepName: string): string {
    return this.selectedPlateStepsMap.get(stepName).startPUID;
  }

  getProcessStepStartTimestamp(stepName: string): Date {
    return this.selectedPlateStepsMap.get(stepName).startTimeStamp;
  }

  searchForPlate() {
    if(!this.plateToSearch || this.plateToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Please enter a plateID',
        detail: 'Plate ID cannot be empty, please enter something to search'
      })
      return;
    }
    this.searchForPlateAction(this.plateToSearch);
  }

  searchForSample() {
    if(!this.sampleToSearch && this.sampleToSearch===''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Enter sample ID to search',
        detail: 'Please enter something to search'
      })
      return;
    }
    this.blocked = true
    this.announcedService.getSampleFromDelivery(this.selectedLabId,this.sampleToSearch).subscribe({
    next : (result) => {
      let sample = result.data[0]
      let sample_id = sample['_id']
      this.platePreparationService.fetchPlateBySample(sample_id, this.selectedLabId).subscribe({
        next : (result) => {
          this.blocked = false
          this._messagesService.addSuccessMessage({
            severity: 'success', detail: 'Sample search success!'
          })
          this.selectedPlate = result;
          this.prepareProcessStepsMap();
          this.prepareSamplesMap();
        },
        error: (error: any) => {
          console.log("Error in pulling plate by sample ", error);
          this.showError(error)
        }
      })
    },
    error: (error: any) => {
      this.showError(error)
    }})
  }

  isScanElementDisabled() {
    return false;
  }

  showError(error: any) {
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  getSampleAt(row: number, col: number) {
    let positionString = this.getRowColStringFromPos(row, col);
    if (this.plateSampleMap.has(positionString)) {
      return this.plateSampleMap.get(positionString);
    }
    let sample = new Sample();
    sample.sampleID='';
    return sample;
  }

  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders[row] + this.columnHeaders[col];
  }

  disableStartQCScanButton(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || this.selectedPlateStepsMap.has(ProcessStep.QC_SCAN) || !this.selectedPlateStepsMap.has(ProcessStep.RECEIVE_PLATE))
      return true
  }

  disableScanBarcodeInput(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || !this.selectedPlateStepsMap.has(ProcessStep.QC_SCAN) || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endPUID || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endTimeStamp)
      return true
  }

  disableStorageButton(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null )
      return true
  }

  disableSavePlateButton(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || !this.selectedPlateStepsMap.has(ProcessStep.QC_SCAN) || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endPUID || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endTimeStamp  || !this.selectedPlateStepsMap.has(ProcessStep.RECEIVE_PLATE))
      return true
  }

  disableCompleteQCScanButton(){
    if(this.selectedPlate.plateID === undefined || this.selectedPlate.plateID === null || !this.selectedPlateStepsMap.has(ProcessStep.QC_SCAN) || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endPUID || this.selectedPlateStepsMap.get(ProcessStep.QC_SCAN).endTimeStamp)
      return true
  }

  completeQCScan() {
    let qcScanCheck = false;
    this.selectedPlate.samples.forEach(ele => {
      if (ele.color == 'white') {
        this.showQcScanNotCompletedPopup = true;
        qcScanCheck = true;
      }
    })
    if (!qcScanCheck) {
      this.updateQCPlate();
    }
  }

  updateQCPlate() {
    var existingStep = this.selectedPlate.processSteps.find(s => s.step == ProcessStep.QC_SCAN);
    existingStep.endTimeStamp = new Date();
    existingStep.endPUID = this.puid;
    this.selectedPlate.status = PlateStatus.QCSCAN_COMPLETED;
    this.selectedPlate.priority = this.selectedPlate.reRun ? 0 : this.selectedPlate.samples.reduce((minPriority,sample) => Math.min(minPriority,sample.priority),10)
    this.updatePlate();
    this.showQcScanNotCompletedPopup = false;
  }

  goBackCompleteScan(){
    this.showQcScanNotCompletedPopup = false;
  }

  startQCScan(){
    var newStep = new Step();
    newStep.step = ProcessStep.QC_SCAN;
    newStep.startTimeStamp = new Date();
    newStep.startPUID = this.puid;
    //server is forcing to put default/dummy values, otherwise it is throwing 500
    newStep.liquidHandler = "";
    newStep.endPUID = "";
    newStep.endTimeStamp = null;
    newStep.chemicals=[];
    newStep.action = [];
    this.selectedPlate.processSteps.push(newStep);
    this.selectedPlate.status = PlateStatus.QCSCAN_STARTED;
    this.updatePlate();
  }

  saveComment(qcBarcodeId){
    if(qcBarcodeId == null || qcBarcodeId == undefined || qcBarcodeId == ''){
      return;
    }
    this.announcedService.updateSampleComment(this.selectedLabId, qcBarcodeId, this.getCommentDTO()).subscribe({
      next : (result) => {
        this.newComment = "";
        this.showCommentsDialog = false;
      },
      error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error })
      }
    })
  }

  getCommentDTO(){
    const newComment = new SampleCommentDTO();
    newComment.puid = this.puid;
    newComment.status = "QC_SCAN";
    newComment.comment = this.newComment;
    return newComment;
  }

  showStorageDialog(){
    this.showStoreDialog = true
  }

  saveToStorage(){
    if(this.selectedStorageLocation === '' || this.selectedStorageLocation === undefined){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Storage Location Not Selected',
        detail: "Storage location cannot be empty. Please select a storage location."
      });
      return;
    }
    this.blocked = true
    this.storageService.searchStorageByPlate(this.selectedLabId,this.selectedPlate.plateID).subscribe({
      next : (result) => {
        this.blocked = false
        let currentPlateLocationInStorage = result.storageName
        if(currentPlateLocationInStorage === this.selectedStorageLocation["storageName"]){
          this._messagesService.addWarningMessage({
            severity:'warn',summary:'Invalid operation',
            detail:`Plate ${this.selectedPlate.plateID} is already in ${result.storageName}. Cannot move to the same location.`
          })
          return
        }

        let plateMigratingData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.selectedPlate.plateID,
          storageName: this.selectedStorageLocation["storageName"],
          oldStorageName: currentPlateLocationInStorage
        }
        this.blocked = true
        this.storageService.addPlateToStorage(plateMigratingData).subscribe({
          next:_r => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.plateID+" added successfully to storage "+this.selectedStorageLocation['storageName']
            });
            this.showStoreDialog = false

          },
          error:error => {
            this.blocked = false
            this.showStoreDialog = false
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.statusText
            });
          }
        })
      },
      error: (_e: any) => {
        let plateData: StoragePlateDTO = {
          labid: this.selectedLabId,
          plateid: this.selectedPlate.plateID,
          storageName: this.selectedStorageLocation["storageName"]
        };
        this.blocked = true
        this.storageService.addPlateToStorage(plateData).subscribe({
          next : (_r) => {
            this.blocked = false
            this._messagesService.addSuccessMessage({
              severity: 'success', summary: 'Plate Added Successfully',
              detail: this.selectedPlate.plateID+" added successfully to storage "+this.selectedStorageLocation['storageName']
            });

            this.markPlatesAsStorage()
          },
          error: (error: any) => {
            this.blocked = false
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Plate Not Added',
              detail: error.error
            });

          }
      });
        this.findAndHighlightElement("plate-id-input");
      }

  })
  }


  removeSamplesPopup(){
    this.sampleList = []
    this.sampleIDList = []
    this.samplePositionList = []
    this.barcodeIDMap = new Map();
    this.barcodePositionMap = new Map();
    this.enteredSampleId = ""
    this.selectedPlate.samples.forEach(samp => {
      this.barcodeIDMap.set(samp.sampleID, samp._id)
      this.barcodePositionMap.set(samp.sampleID, samp.position)
    })
    this.removeSamples = !this.removeSamples
  }
  disableScanCompleteButton(){
    return (this.selectedPlate.plateID == '' || this.selectedPlate.workFlow == '' || this.selectedPlate.workFlow == null || this.selectedPlate.sender == '' || this.selectedPlate.sender == null || this.selectedPlate.status == PlateStatus.QCSCAN_COMPLETED)
  }

  checkSample(){
    if(this.barcodeIDMap.has(this.enteredSampleId)){
      this.sampleList.push(this.enteredSampleId)
      //For samples processing service
      this.sampleIDList.push(this.barcodeIDMap.get(this.enteredSampleId))

      //For delivery service
      this.samplePositionList.push(this.barcodePositionMap.get(this.enteredSampleId))

      this.enteredSampleId = ""
    }
    else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Barcode not present in Plate',
        detail: "Barcode not present in Plate",
      })
      this.enteredSampleId = ""
    }
  }

  deleteValue(index){
    this.sampleIDList.splice(index,1);
    this.sampleList.splice(index,1);
    this.findAndHighlightElement('popup-plateid');
  }
  disableRemoveSamplesButton(){
    return !(this.sampleList.length>0)
  }

  deleteSamples(){
    const body = prepareRemoveSampleDTO(
        this.selectedPlate,
        this.selectedLabId,
        this.samplePositionList,
        this.puid,
        this.sampleBarcodeMap
    );
    this.blocked = true;
    this.platePreparationService.removeSamples(body).subscribe( {
      next : (res_samples) => {
      body["sampleList"] = this.sampleIDList
      body["resetProcessingStartDate"] = !this.selectedPlate.storage;
      this.announcedService.removeSamples(body).subscribe( _res_delivery => {
        this.searchForPlateAction(this.selectedPlate.plateID)
        this.blocked = false;
        this.removeSamples = !this.removeSamples
        this.sampleList = []
        this.sampleIDList = []
        this.samplePositionList = []
        this.enteredSampleId = ""
        this._messagesService.addSuccessMessage({
          severity: 'success',
          summary: 'Success',
          detail: "Samples successfully deleted" })
      })
    },
    error: (error: any) => {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Error',
        detail: "Sample was not deleted" })
    }})
  }

  showComments(){
    this.beadChipCommentsDisplayMap.clear();
    this.beadChipCommentsDisplayMap.set("showPlateCommentList",false)
    this.beadChipCommentsMap.clear();
    this.platePreparationService.commentDetailsbyPlateId(this.selectedLabId,this.selectedPlate.plateID).subscribe({
      next : (result) => {
        this.fetchedCommentsPlate = result;
        this.selectedPlateID = this.fetchedCommentsPlate.plateID;
        this.selectedPlateStatus = this.selectedPlate.status;
        this.plateCommentsList = this.fetchedCommentsPlate.comments;
        if(this.fetchedCommentsPlate && this.fetchedCommentsPlate.beadChips){
          this.fetchedCommentsPlate.beadChips.forEach(beadChip=>{
            this.beadChipCommentsMap.set(beadChip.beadChipID,beadChip.comments)
            this.beadChipCommentsDisplayMap.set(beadChip.beadChipID,false);
          })
        }
      },
      error: (error: any) => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Error', detail: error.error });
      }
    })

  }

  onApplyFilter(){
    let queryStatusList = this.selectedStatuses.join(',');
    let querysampleTypeList = this.selectedProcessFlowList.join(',');
    this.fetchReceivedPlates(queryStatusList, querysampleTypeList, this.fromDate);
  }

  fetchReceivedPlates(status?: string, processFlowName?: string, fromDate?: Date) {
    this.loading = true;
    if(status === '' || status == undefined){
      status = this.statusFilterList.join(',');
    }
    if(processFlowName === ''){
      processFlowName = undefined;
    }
    this.platePreparationService.fetchPlates(this.preparePlateSearchDTO(this.selectedLabId, "PLATE", status, processFlowName, fromDate)).subscribe({
      next : (result) => {
        this.plates = result;
        this.loading = false;
        if(this.selectedPlate.plateID != null){
          for(let i=0; i<this.plates.length; i++){
            if(this.selectedPlate.plateID == this.plates[i].plateID){
              this.tableSelectedRow = this.plates[i]
              break
            }
          }
        }
      },
      error: (error: any) => {
        this.loading = false;
        this._messagesService.addErrorMessage({
          severity: 'error', summary: 'Failed to fetch plates',
          detail: 'Some issue in pulling the plates info, please try again'
        })
      }})
  }

  resetAllFilter(){
    this.selectedStatuses = [];
    this.selectedProcessFlowList = [];
    this.fromDate = undefined;
    this.fetchReceivedPlates();
  }

  convertToDate(date: Date): Date {
    if (!date || date == null) return;
    return new Date(date);
  }

  closeShowSampleAsidePouUp(){
    this.showSampleAsidePouUp = false;
    this.previousScannedBarcode = this.scannedBarcode;
    this.scannedBarcode = '';
    this.topBarcode = '';
    this.bottomBarcode = '';
    this.findAndHighlightElement('barcode-scanner');
  }

  disableContinueButton(){
    return (this.topBarcode == null || this.bottomBarcode == null)
  }

  getFileUploadStyle() {
    return {
      'margin-top': '1%',
      'font-weight': 'bold',
      'font-size': '14px',
      'padding': '7px 0px 7px 0px',
      'border-radius': '5px',
      'background-color': 'rgb(65, 130, 126)',
      'border': 'none',
      'width': '9rem'
    }
  }

  onInternalFileSelect(event){
    if(!(event.files[0].type === "application/vnd.ms-excel")){
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only.xls files are allowed.'
      });
    }
  }

  validateSamples(event, fileUploader: HTMLInputElement){
    const formData = new FormData();
    formData.append('file', event.files[0]);
    formData.append('labID', this.selectedLabId);
    formData.append('plateID', this.selectedPlate.plateID);
    this.blocked = true;
    this.platePreparationService.uploadExcelFileForValidateSamples(formData).subscribe({
      next : (_result) => {
        this.blocked = false;
        this.searchForPlateAction(this.selectedPlate.plateID);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'QC Scan',
          detail: "QC Scan file uploaded Successfully"
        });
        this.fileUploadElement.clear();
      },
      error: (error: any) => {
        this.blocked = false;
        this.fileUploadElement.clear();
        this.showError(error);
      }
    });
  }

  closeShowSampleNotPresentDialog(){
    this.showSampleNotPresentDialog = false;
    this.findAndHighlightElement('barcode-scanner');
  }

  getSelectedCellPosition(){
    if(this.selectedPlate.scanHorizontal){
      for(let i=0; i<this.rowHeaders.length; i++){
        for(let j=0; j<this.columnHeaders.length; j++){
          if(this.qcScanPostionMap.has(this.rowHeaders[i]+ this.columnHeaders[j])){
            this.selectedCell = this.rowHeaders[i]+ this.columnHeaders[j]
            return
          }else{
            this.selectedCell = 'A1'
          }
        }
      }
    }
    else{
      for(let i=0; i<this.columnHeaders.length; i++){
        for(let j=0; j<this.rowHeaders.length; j++){
          if(this.qcScanPostionMap.has(this.rowHeaders[j]+ this.columnHeaders[i])){
            this.selectedCell = this.rowHeaders[j]+ this.columnHeaders[i]
            return
          }else{
            this.selectedCell = 'A1'
          }
        }
      }
    }
  }
  getPriorityClass(priority:number){
    return priorityMap[priority]
  }

  setGreenColorToCell() {
    let plateSample = this.plateSampleMap.get(this.selectedCell);
    plateSample.color = '#90ee90';
    this.plateSampleMap.set(this.selectedCell, plateSample);
    this.saveBottomBarcode()
    this.savePlate();
    this.incrementSelectedCell();
    this.showSampleMismatchDialog = false;
    this.scannedBarcode = '';
    this.previousScannedBarcode = '';
  }

  clearPopUpFields(){
    this.topBarcode = '';
    this.bottomBarcode = '';
    this.scannedBarcode = '';
  }

  hideDialog(reloadPlateData: boolean = false){
    if(reloadPlateData){
      this.searchForPlateAction(this.selectedPlate.lastUpdatedPlateID)
    }
  }

  convertUtcToLocal(date: Date){
    if(!date || date==null) {
      return null
    };

    const offset = new Date().getTimezoneOffset();
    const dateInLocal = new Date(date);
    dateInLocal.setMinutes(dateInLocal.getMinutes()-offset);
    return dateInLocal;
  }

  checkIfSampleIsDisabledForSelection(sample: Sample): boolean {
    return sample.receptionStatus === "REMOVED" || sample.sampleCompletionDate !== null;
  }

  checkStatusChange(plate: Plate): boolean{
    return plate?.lastModifiedDate === plate?.adminChangeTimeStamp;
  }

}
